import { useAddFavoriteChannel } from './useAddFavoriteChannel';
import { useDeleteFavoriteChannel } from './useDeleteFavoriteChannel';

export function useFavorites() {
  const { add: addFavoriteChannel } = useAddFavoriteChannel();
  const { delete: deleteFavoriteChannel } = useDeleteFavoriteChannel();

  return {
    addFavoriteChannel,
    deleteFavoriteChannel,
  };
}
